<template>
    <div class="new-cell-group">
        <van-cell-group title="订单信息">
            <van-card
                v-for="(goodsItem, goodsIndex) in detail.detail.exchange_goods"
                :key="goodsIndex" :num="goodsItem.buy_number"
                :thumb="goodsItem.image"
                style="background-color: #ffffff;margin-bottom: 0.5rem;">
                <template #price>
                    <span class="base-theme-text" style="font-size:14px;">
                        {{goodsItem.integral > 0 ? goodsItem.integral + '积分' : ''}}
						{{goodsItem.integral > 0 && goodsItem.amount > 0 ? '+' : ''}}
						{{goodsItem.amount > 0 ? goodsItem.amount + '元' : ''}}
                    </span>
                </template>
                <template #title>
                    <div style="font-size: 18px;">{{goodsItem.title}}</div>
                </template>
            </van-card>
            <van-cell class="order-no-cell" title="订单编号：" :value="detail.order_no"/>
            <van-cell title="总积分" :value="detail.total_integral"/>
			<van-cell title="总金额" :value="detail.total_amount"/>
            <van-cell title="下单时间：" :value="detail.created_at"/>
            <van-cell title="订单状态：" :value="$store.state.systemEnum['company']['user_integral_order']['status'][detail.status]"/>
            <van-cell title="使用卡兑换：">
                <van-tag v-for="(cardItem, cardIndex) in detail.use_user_card_info" :key="cardIndex" size="large" color="#576b95" style="margin-bottom: 5px;">No.{{cardItem.card_no}}</van-tag>
            </van-cell>
            <van-cell v-if="Number(detail.status) === 0 && detail.total_amount > 0">
				<div>
					<van-button type="danger" round class="button-in-cell" @click="cancel(detail.order_no)">取消订单</van-button>
					<van-button type="info" round class="button-in-cell" @click="payAgain(detail.order_no)">立即付款</van-button>
				</div>
            </van-cell>
            <!-- <van-cell v-if="refundStatus.indexOf(Number(detail.status)) !== -1 && detail.total_amount > 0">
				<div>
					<van-button type="danger" round class="button-in-cell" @click="showRefund(detail.order_no)">退款</van-button>
				</div>
            </van-cell> -->
        </van-cell-group>
        <van-cell-group title="商品兑换码" v-if="detail.provide_user_exchange_info && detail.provide_user_exchange_info.length > 0">
            <div :class="{ 'exchange-item' : true, 'write-off' : exchangeItem.status === '1' }" v-for="(exchangeItem, exchangeIndex) in detail.provide_user_exchange_info" :key="exchangeIndex">
                <div class="exchange-code">
                    <span class="exchange-code-title">商品兑换码</span>
                    <span class="exchange-info" v-if="exchangeItem.expire_time">请在{{exchangeItem.expire_time}}前凭此兑换码到油站兑换商品</span>
                    <span class="exchange-code-text">{{splitCode(exchangeItem.code)}}</span>
                </div>
                <div class="exchange-qrcode">
                    <qriously :value="exchangeItem.code" :size="200" :foreground-alpha="exchangeItem.status === '1' ? 0.3 : 1" />
                </div>
                <div class="write-off-text">已核销</div>
            </div>
        </van-cell-group>

		<van-popup v-model="showPaymentPassword" position="bottom" style="height: 90%;">
			<div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">输入支付密码</div>
			<div style="text-align: center; color: #888888; padding: 10px;">请输入支付密码，用于验证支付</div>
			<van-password-input :value="paymentPassword" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
			<van-number-keyboard v-model="paymentPassword" :show="showPaymentPasswordKeyboard" :maxlength="6" />
		</van-popup>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import common from '../../assets/js/common'

    export default {
        name: 'IntegralOrderDetail',
        data () {
            return {
                detail : {
                    detail : {},
                },
				use_user_card_info : [],
				showPaymentPassword : false,
				showPaymentPasswordKeyboard : true,
				paymentPassword : '',
				refundStatus: [1, 2, 4]
            };
        },
		watch: {
			// paymentPassword(newValue, oldValue){
            //     if(newValue.length >= 6){
            //         this.refund();
            //     }
            // }
		},
        created() {
            let self = this;
            api.request('/integral_order/detail', {
                'order_no' : this.$route.query.orderNo,
            }).then(res => {
                self.detail = res.data;
            })
        },
        methods : {
            splitCode(value){
                let needleSplitVal = value;
                let valArr = [];
                while (needleSplitVal.length > 4){
                    valArr.push(needleSplitVal.substr(0, 4));
                    needleSplitVal = needleSplitVal.substring(4);
                }
                if(needleSplitVal){
                    valArr.push(needleSplitVal);
                }
                return valArr.join(' ');
            },

			cancel(id) {
				if (this.isLoading) return;
				let self = this;
				this.$dialog.confirm({
				message: '是否确认取消该订单?',
				})
				.then(() => {
					this.isLoading = true;
					self.$toast.fail('正在取消订单');
					api.request('/integral_order/cancel', {
						order_no: id
					}).then(res => {
						self.$toast.fail('订单已取消');
						self.$router.go(0)
					}).catch(res => {
						self.$toast.fail('订单取消失败');
					}).finally(() => {
						self.isLoading = false;
					});
				})
				.catch(() => {
					// on cancel
				});
			},

			payAgain(id) {
				if (this.isLoading) return;
				let self = this;
				this.isLoading = true;
				api.request('/integral_order/pay_again', {
				    order_no: id
				}).then(res => {
                    if(res.data.payment_info){
                        let paymentInfo = JSON.parse(res.data.payment_info);
                        common.wechatPayReady(paymentInfo.appId, () => {
                            wx.chooseWXPay({
                                timestamp: paymentInfo.timeStamp,
                                nonceStr: paymentInfo.nonceStr,
                                package: paymentInfo.package,
                                signType: paymentInfo.signType,
                                paySign: paymentInfo.paySign,
                                success(res) {
                                    self.$toast({
                                        message : '兑换成功',
                                        onClose(){
											self.$router.replace({
												name : 'IntegralOrderDetail',
												query : {
													orderNo : id,
												},
											})
                                        },
                                    });
                                },
                                cancel(res) {
									self.$router.replace({
										name : 'IntegralOrderDetail',
										query : {
											orderNo : id,
										},
									})
                                },
                                fail(res){
                                    self.$toast(res.errMsg);
                                },
                            });
                        });
                    }
				}).catch(res => {
				    self.$toast.fail('获取支付配置失败');
				}).finally(() => {
					self.isLoading = false;
				});
			},

			// showRefund(id) {
			// 	this.showPaymentPassword = true;
			// },

			// refund() {
			// 	if (this.isLoading) return;
			// 	let self = this;
			// 	let id = this.detail.order_no;
			// 	this.isLoading = true;
			// 	self.$toast.fail('正在发送退款请求');
			// 	api.request('/company/user_integral_order/refund', {
			// 	    order_no: id,
			// 		password: this.paymentPassword
			// 	}).then(res => {
			// 	    self.$toast.fail('申请成功');
			// 	    self.$router.replace({
			// 			name : 'IntegralOrderDetail',
			// 			query : {
			// 				orderNo : id,
			// 			},
			// 		})
			// 	}).catch(res => {
			// 	    self.$toast.fail(res.msg);
			// 	}).finally(() => {
			// 		self.isLoading = false;
			// 	});
			// }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';

	.button-in-cell {
		float: right;
		height: 1rem;
		margin-left: 15px;
	}

    .order-no-cell{
        .van-cell__title{
            flex: 1;
        }
        .van-cell__value{
            flex: 2;
        }
    }
    .exchange-item{
        width: 95%;
        padding: 10px 0;
        border-top: 1px dashed #cccccc;
        position: relative;
        background: #ffffff;
        border-radius: 0.3rem;

        &:first-child{
            border-top: none;
        }
        &.write-off{
            .exchange-code{
                .exchange-code-text{
                    color: #cccccc;
                }
            }
            .write-off-text{
                display: block;
            }
        }

        .exchange-info {
            font-size: 15px;
            text-align: center;
            display: block;
            width: 60%;
            margin: auto;
            padding: 10px;
            color: #da4242;
        }
        .exchange-code{
            font-size: 0.6rem;
            text-align: center;
            padding-bottom: 10px;

            .exchange-code-title {
                display: block;
                font-size: 0.35rem;
                margin-bottom: 0.1rem;
                color: #888;
            }
            .exchange-code-text{
                display: block;
                width: 90%;
                margin: auto;
                padding: 10px;
                color: #575757;
            }
        }
        .exchange-qrcode{
            padding: 10px;
            border: 1px solid #eeeeee;
            width: 200px;
            margin: auto;
        }

        .write-off-text{
            font-size: 30px;
            font-weight: bold;
            width: 130px;
            height: 130px;
            line-height: 130px;
            text-align: center;
            color: #767676;
            border: 5px solid #767676;
            border-radius: 1000px;
            position: absolute;
            right: 30px;
            bottom: 30px;
            transform: rotate(-30deg);
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/IntegralOrderDetail.vue